import { contactService } from '../services'
import Vue from 'vue'
import saveAs from 'file-saver'

const state = {
  all: {
    filterInitialized: false,
    defaultFilter: {
      projectId: null,
      firstName: null,
      lastName: null,
      freeText: null,
      email: null,
      mobilePhone: null,
      orderByColumn: 'firstName',
      orderByDescending: false
    },
    currentPage: 1,
    loading: true,
    saving: false,
    items: [],
    filter: {},
    meta: {}
  }
}

const actions = {
  initialize ({ commit }) {
    commit('initialize')
  },

  resetFilter ({ commit }) {
    commit('resetFilter')
  },

  getAll ({ commit }) {
    return contactService.getAll()
      .then(
        data => {
          return data.result
        }
      )
  },

  getListData ({ commit }) {
    commit('getListDataRequest')

    return contactService.getListData(state.all.filter, state.all.currentPage)
      .then(
        data => {
          commit('getListDataSuccess', data.result)
          return data.result
        }
      )
  },

  getById ({ commit }, id) {
    return contactService.getById(id)
  },

  getContactsByProjectId ({ commit }, id) {
    return contactService.getContactsByProjectId(id)
  },

  create ({ commit, dispatch }, contact) {
    commit('startSave')
    return contactService.create(contact)
      .then(contact => {
        commit('endSave')
        commit('createSuccess', contact)
        dispatch('getListData')
        return contact.result
      }).catch(error => {
        commit('endSave')
        commit('createFailure')
        return Promise.reject(error)
      })
  },

  createProjectContact ({ commit, dispatch }, contact) {
    commit('startSave')
    return contactService.createProjectContact(contact)
      .then(contact => {
        commit('endSave')
        commit('createProjectContactSuccess', contact.result)
        // dispatch('getListData')
        return contact
      }).catch(error => {
        commit('endSave')
        commit('createProjectContactFailure')
        return Promise.reject(error)
      })
  },

  update ({ commit }, contact) {
    commit('startSave')
    return contactService.update(contact)
      .then(contact => {
        commit('endSave')
        commit('updateSuccess', contact.result)
        return contact
      }).catch(error => {
        commit('endSave')
        commit('updateFailure')
        return Promise.reject(error)
      })
  },

  delete ({ commit }, id) {
    commit('startSave')

    commit('deleteRequest', id)

    contactService.delete(id)
      .then(contact => {
        commit('endSave')
        commit('deleteSuccess', id)
      })
  },

  downloadPersonAsCsv ({ commit }, id) {
    contactService.downloadPersonAsCsv(id)
      .then(response => {
        var blob = new Blob([response.data])
        saveAs(blob, 'contact.xlsx')
      }).catch(error => {
        console.error(error)
      })
  }
}

const getters = {
  isFilterChanged: state => (route) => {
    // Page should not be considered when comparing
    const currentFilter = Object.assign({}, state.all.filter)
    const defaultFilter = Object.assign({}, state.all.defaultFilter)

    currentFilter.currentPage = null
    defaultFilter.currentPage = null

    return !Vue.lodash.isEqual(currentFilter, defaultFilter)
  }
}

const mutations = {
  resetFilter (state) {
    state.all.currentPage = 1
    state.all.filter = Object.assign({}, state.all.defaultFilter)
  },

  initialize (state) {
    if (!state.all.filterInitialized) {
      mutations.resetFilter(state)
      state.all.filterInitialized = true
    }
  },

  startSave (state) {
    state.all.saving = true
  },

  endSave (state) {
    setTimeout(() => {
      state.all.saving = false
    }, 200)
  },

  // Get all
  getListDataRequest (state) {
    state.all.loading = true
  },
  getListDataSuccess (state, data) {
    state.all.items = data.items
    state.all.meta = data.meta
    state.all.loading = false
  },
  getListDataFailure (state, error) {
    state.all.error = error
    state.all.loading = false
  },

  // Create
  createSuccess (state, updatedContact) {
    /*
    state.all.items = state.all.items.map(contact =>
      contact.contactId === updatedcontact.contactId ? updatedcontact : contact
    )
    */
    Vue.prototype.$toast('Kontakt skapad', 'success')
  },
  createFailure (state, error) {
    Vue.prototype.$toast('Kunde inte skapa den nya kontakten', 'error')
  },
  createProjectContactSuccess (state, updatedContact) {
    Vue.prototype.$toast('Projektkoppling skapad', 'success')
  },
  createProjectContactFailure (state, error) {
    Vue.prototype.$toast('Kunde inte skapa den nya projekkopplingen', 'error')
  },

  // Update
  updateSuccess (state, updatedContact) {
    state.all.items = state.all.items.map(contact =>
      contact.contactId === updatedContact.contactId ? updatedContact : contact
    )

    Vue.prototype.$toast('Person uppdaterad', 'success')
  },
  updateFailure (state) {
    Vue.prototype.$toast('Kunde inte uppdatera personen', 'error')
  },

  // Delete
  deleteRequest (state, id) {
    // add 'deleting:true' property to contact being deleted
    state.all.items = state.all.items.map(contact =>
      contact.contactId === id
        ? { ...contact, deleting: true }
        : contact
    )
  },
  deleteSuccess (state, id) {
    // remove deleted contact from state
    state.all.items = state.all.items.filter(contact => contact.contactId !== id)
  }
}

export const contacts = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/contact.module.js